export function isTimeWithinRange(time: number, start: number, end: number): boolean {
  return time >= start && time <= end;
}
